var map = {
	"./ArrowRightCard.svg": 71665,
	"./action-pencil.svg": 57344,
	"./add.svg": 14780,
	"./arrow-down.svg": 24746,
	"./arrow-right.svg": 80153,
	"./back-to-default.svg": 44019,
	"./back.svg": 37911,
	"./bell.svg": 24565,
	"./billing.svg": 76226,
	"./board.svg": 65454,
	"./book-open.svg": 65633,
	"./building.svg": 38352,
	"./calendar-money.svg": 94780,
	"./calendar.svg": 90874,
	"./cart.svg": 49163,
	"./check-circle.svg": 21529,
	"./check.svg": 90706,
	"./clipboard.svg": 84092,
	"./clipboard2.svg": 69637,
	"./close.svg": 50420,
	"./code.svg": 19156,
	"./copy.svg": 47918,
	"./crosshair.svg": 65085,
	"./custom-design.svg": 41301,
	"./dashboard.svg": 77553,
	"./date.svg": 83341,
	"./dollor-icon.svg": 25609,
	"./dots-horizontal.svg": 68548,
	"./down.svg": 6951,
	"./download.svg": 39007,
	"./exit.svg": 53578,
	"./filter.svg": 63817,
	"./grid-bg.svg": 46331,
	"./grid.svg": 12637,
	"./hotel.svg": 14983,
	"./left.svg": 47042,
	"./link.svg": 27966,
	"./list.svg": 57380,
	"./mark.svg": 31491,
	"./menu.svg": 85674,
	"./more.svg": 74041,
	"./myhotel.svg": 40411,
	"./note.svg": 53220,
	"./pay.svg": 18997,
	"./payed.svg": 66959,
	"./pencil.svg": 61265,
	"./pencil2.svg": 6902,
	"./pie-chart.svg": 85712,
	"./printer.svg": 11732,
	"./profile.svg": 77820,
	"./promotion.svg": 99286,
	"./refresh.svg": 39525,
	"./reload.svg": 16939,
	"./reload2.svg": 48784,
	"./right.svg": 73756,
	"./search.svg": 79262,
	"./server.svg": 68455,
	"./settings.svg": 20677,
	"./trash.svg": 10967,
	"./trending-down.svg": 57992,
	"./trending-up-gray.svg": 99518,
	"./trending-up.svg": 17887,
	"./user-light.svg": 35968,
	"./user-mini.svg": 34453,
	"./user.svg": 51816,
	"./user_checked.svg": 40067,
	"./warning-info.svg": 13782,
	"./x.svg": 74118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;